import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import {
  buildGestorDashboardBackPath,
} from '@/components/Gestores/gestorDashboardNavigation'
import type { GestorDashboardTaskDetail } from '@/components/Gestores/gestorDashboardTypes'
import { gestoresService } from '@/services/gestoresService'
import { getFriendlyError } from '@/utils/getFriendlyError'

export function useGestorDashboardTaskDetailPage() {
  const navigate = useNavigate()
  const { taskId = '' } = useParams()
  const [searchParams] = useSearchParams()
  const [detail, setDetail] = useState<GestorDashboardTaskDetail | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const createdFrom = searchParams.get('createdFrom') ?? undefined
  const createdTo = searchParams.get('createdTo') ?? undefined
  const squadIdParam = searchParams.get('squadId')
  const squadId = squadIdParam ? Number(squadIdParam) : undefined

  const load = useCallback(async () => {
    const parsedTaskId = Number(taskId)
    if (!Number.isInteger(parsedTaskId) || parsedTaskId <= 0) {
      setError('ID de tarefa inválido.')
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)
    try {
      const data = await gestoresService.getDashboardTask(parsedTaskId, {
        createdFrom,
        createdTo,
        squadId,
      })
      setDetail(data)
    } catch (err) {
      const message = getFriendlyError(err, 'Não foi possível carregar a tarefa')
      setError(message)
      setDetail(null)
      toast.error(message)
    } finally {
      setLoading(false)
    }
  }, [createdFrom, createdTo, squadId, taskId])

  useEffect(() => {
    void load()
  }, [load])

  const goBack = useCallback(() => {
    navigate(buildGestorDashboardBackPath())
  }, [navigate])

  return { detail, loading, error, goBack, reload: load }
}
